var _path, _circle, _ellipse, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1089 20.2227H2.88672V24.556H4.86298C6.2427 24.556 7.43982 25.5083 7.75006 26.8527L11.5534 43.3338H11.8C12.3948 41.6507 14 40.4449 15.8867 40.4449C17.4008 40.4449 18.7334 41.2214 19.5083 42.3978C19.8536 42.9222 20.3933 43.3338 21.0211 43.3338H30.9745C31.6024 43.3338 32.142 42.9222 32.4874 42.3978C33.2622 41.2214 34.5949 40.4449 36.1089 40.4449C37.9957 40.4449 39.6008 41.6507 40.1957 43.3338H40.4423L44.2456 26.8527C44.5558 25.5083 45.753 24.556 47.1327 24.556H49.1089V20.2227Z",
    fill: "#256AF5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8889,
    cy: 44.778,
    r: 2.88889,
    fill: "#256AF5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1096,
    cy: 44.778,
    rx: 2.88889,
    ry: 2.88889,
    fill: "#256AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2793 28.166H39.7237L39.0015 30.3327H13.0015L12.2793 28.166Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7188 33.9443H38.2743L37.5521 36.111H14.441L13.7188 33.9443Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3654 17.3326H38.8972L36.3178 12.1738L34.1353 10.1104H30.6432L28.0274 12.1035L28.0626 12.174L29.0943 14.7534L27.0387 12.6978L25.4051 11.6308L21.04 11.2507L19.294 13.5314L16.2384 13.1513L13.6194 15.432L13.1035 17.3326H15.3654Z",
    fill: "#3BB56C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoal);
export default __webpack_public_path__ + "static/media/coal.c5be36c3e7ad789fa403247f168acbd0.svg";
export { ForwardRef as ReactComponent };